export default __webpack_public_path__ + "static/media/img-25-cyfrin.3614b85e.jpg";